import { TYPE_OPTION, TYPE_QUESTION } from "../actions/constants";

const OPERATORS = {
    "always": { precedence: 3, type: "atomic" },
    "e": { precedence: 3, type: "atomic" },
    "ne": { precedence: 3, type: "atomic" },
    "and": { precedence: 2, type: "compound" },
    "or": { precedence: 1, type: "compound" }
};

const precedence = (op) => {
    return OPERATORS[op].precedence || 0;
}

const createTree = (operator, left, right) => {
    return {
        op: operator,
        vars: [left, right]
    };
}

export const constructEvaluationTree = (tokens) => {
    let operators = [];
    let operands = [];

    for (const token of tokens) {
        if (token.op) {
            if (OPERATORS[token.op].type === "atomic") {
                operands.push(token);
                continue;
            }

            // Handle compound operator
            while (
                operators.length &&
                precedence(operators[operators.length - 1]) >= precedence(token.op)
            ) {
                const operator = operators.pop();
                const rightOperand = operands.pop();
                const leftOperand = operands.pop();
                operands.push(createTree(operator, leftOperand, rightOperand));
            }
            operators.push(token.op);
        }
    }

    while (operators.length) {
        const operator = operators.pop();
        const rightOperand = operands.pop();
        const leftOperand = operands.pop();
        operands.push(createTree(operator, leftOperand, rightOperand));
    }

    return operands[0];
}

export const treeToTokens = (tree) => {
    let tokens = [];

    if (!tree) return tokens;

    if (!tree.op) {
        throw new Error("Invalid node: node does not have an 'op' property.");
    }

    if (OPERATORS[tree.op].type === "atomic") {
        tokens.push(tree);
        return tokens;
    }

    if (tree.vars && tree.vars.length === 2) {
        tokens = tokens.concat(treeToTokens(tree.vars[0]));  // left child
        tokens.push({ op: tree.op });  // current node operator
        tokens = tokens.concat(treeToTokens(tree.vars[1]));  // right child
    } else {
        throw new Error(`Invalid node: node with operator '${tree.op}' does not have two children.`);
    }

    return tokens;
}

export const convertTokensToExpressions = (tokens) => {
    const expression = [];

    if (!tokens) return expression;

    let currentCompoundOperator = null;

    for (const token of tokens) {
        if (OPERATORS[token.op].type === "atomic") {
            const question = token.vars.find((varItem) => varItem.type === TYPE_QUESTION);
            const option = token.vars.find((varItem) => varItem.type === TYPE_OPTION);

            if (question && option) {
                const expressionItem = {
                    question: question.value,
                    operator: token.op,
                    option: option.value,
                };

                if (currentCompoundOperator) {
                    expressionItem.compound_operator = currentCompoundOperator;
                    currentCompoundOperator = null;
                }

                expression.push(expressionItem);
            }
        } else {
            currentCompoundOperator = token.op
        }
    }

    return { expression };
};

export const convertExpressionsToTokens = (expressions) => {
    const tokens = [];

    if (!expressions) return tokens;

    for (const exp of expressions) {
        const token = {};
        if (exp.operator) {
            token.op = exp.operator;
            token.vars = [];

            if (exp.question) {
                token.vars.push({ type: TYPE_QUESTION, value: exp.question });
            }

            if (exp.option) {
                token.vars.push({ type: TYPE_OPTION, value: exp.option });
            }

            if (exp.compound_operator) {
                tokens.push({ op: exp.compound_operator });
            }

            tokens.push(token);
        }
    }

    return tokens;
};